<template>
  <v-container>
    <v-layout column>
      <v-flex grow>
        <v-alert
          v-model="isError"
          dismissible
          type="error"
          transition="fade-transition"
        >
          {{ errMessage }}
        </v-alert>
        <v-alert
          v-model="isSuccess"
          dismissible
          type="success"
          transition="fade-transition"
        >
          Action completed successfully
        </v-alert>
      </v-flex>
      <v-flex>
        <h1>Account</h1>
      </v-flex>
      <v-flex>
        <p>Name: {{ $auth.user().firstName }} {{ $auth.user().lastName }}</p>
      </v-flex>
      <v-flex>
        <p>Email (local): {{ $auth.user().local.email }}</p>
        <v-form @submit="changePasswordSubmit">
          <v-layout column>
            <v-flex>
              <v-text-field
                v-model="oldPassword"
                label="Current Password"
                type='password'
                required
                :error-messages="errors.oldPassword"
                id="oldPassword"
                @focus="inputFocus"
              ></v-text-field>
              <v-text-field
                v-model="password"
                label="Password"
                type='password'
                required
                :error-messages="errors.password"
                id="password"
                @focus="inputFocus"
              ></v-text-field>
              <v-text-field
                v-model="confirm"
                label="Confirm Password"
                type='password'
                required
                :error-messages="errors.confirm"
                id="confirm"
                @focus="inputFocus"
              ></v-text-field>
              <v-btn type="submit">Change Password</v-btn>
            </v-flex>
          </v-layout>
        </v-form>
      </v-flex>
      <v-flex ma-4>
        <hr />
      </v-flex>
      <v-flex v-if="$root.isGoogleAvailable">
        <p>Email (Google): {{ $auth.user().google.email }}</p>
        <p v-if="!$auth.user().google.email"><v-btn @click="this.$root.googleLogin">Link Google Account</v-btn></p>
        <p v-else><v-btn @click="unlinkSocial('google')">Unlink Google Account</v-btn></p>
      </v-flex>
      <v-flex v-if="$root.isFacebookAvailable">
        <p>Email (Facebook): {{ $auth.user().facebook.email }}</p>
        <p v-if="!$auth.user().facebook.email"><v-btn @click="this.$root.facebookLogin">Link Facebook Account</v-btn></p>
        <p v-else><v-btn @click="unlinkSocial('facebook')">Unlink Facebook Account</v-btn></p>
      </v-flex>
      <v-flex>
        <p>Role: {{ $auth.user().roles }}</p>
        <v-btn @click="fetch()">Refresh Information</v-btn>
      </v-flex>
      <v-flex ma-4>
        <hr />
      </v-flex>
      <v-flex>
        <v-btn block to="/subscriptions">View Subscriptions</v-btn>
      </v-flex>
      <v-flex ma-4>
        <hr />
      </v-flex>
      <v-flex>
        <v-btn block to="/logout">Log Out</v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    password: '',
    confirm: '',
    oldPassword: '',
    showPasswordResetPopup: false,
    errors: {
      password: null,
      confirm: null,
      oldPassword: null
    },

    isSuccess: false,
    isError: false,
    errMessage: null
  }),
  methods: {
    fetch: function () {
      this.$auth.fetch()
    },
    changePasswordSubmit: function (ev) {
      ev.preventDefault()

      let _this = this
      this.axios.put('/auth/users/' + this.$auth.user().id + '/password', {
        password: this.password,
        confirm: this.confirm,
        oldPassword: this.oldPassword
      }).then(function () {
        // Clear out our text fields
        _this.password = ''
        _this.confirm = ''
        _this.oldPassword = ''

        // Let the user know it worked
        _this.isSuccess = true
      })
        .catch(this.$root.apiErrorHandler(function (msg, errors) {
          _this.errMessage = msg
          _this.errors = errors
          _this.isError = true
        }))
    },
    unlinkSocial: function (provider) {
      let _this = this
      this.axios.delete('/auth/' + provider)
        .then(function () {
          _this.$auth.fetch()
        })
        .catch(this.$root.apiErrorHandler(function (msg, errors, err) {
          // Use our standard messages by default, but tweak them to be more
          // specific if appropriate.
          _this.errMessage = msg
          if (err && err.response && err.response.status) {
            switch (err.response.status) {
              case 404:
                _this.errMessage = 'Nothing exists to unlink'
                break
              case 409:
                _this.errMessage = 'Cannot unlink when there are no remaining authentication methods'
                break
            }
          }

          _this.isError = true
        }))
    },
    inputFocus (ev) {
      // Clear any errors for an input when it receives focus
      if (ev.target && ev.target.id) {
        this.errors[ev.target.id] = null
      }
    }
  },
  mounted: function () {
    if (this.$auth.flashMessage) {
      this.errMessage = this.$auth.flashMessage
      this.isError = true

      delete this.$auth.flashMessage
    }
  }
}
</script>
